<template>
  <v-sheet class="category-info-sheet--mobile wd-contents">
    <div ref="searchBarRef" class="wd-sticky wd-top-0 wd-pt-3 wd-z-searchBarMobile wd-bg-white">
      <slot name="title">
        <SearchBar :is-navigation="true" :showing-items="!isSearchInputRowShow" />
        <div v-if="isSearchInputRowShow && !isEmbeddedSearchBarVisible" class="py-2 px-5 d-flex align-center">
          <v-btn class="search__btn mr-2 px-2" min-width="24" width="24" height="24" variant="text" @click="leaveingSearchInput">
            <funnow-icon class="wd-w-6" max-width="24" :image-path="'chevron-left.svg'" />
          </v-btn>
          <v-text-field
            class="search-input wd-h-11 wd-w-full"
            :model-value="searchKeyWord"
            color="orange50"
            variant="outlined"
            density="compact"
            hide-details
            @click="openSearchNavigation"
          >
            <template #prepend-inner>
              <funnow-icon class="mr-3" max-width="20" :image-path="'magnify-icon_black.svg'" />
            </template>

            <template #append-inner>
              <v-btn class="clear-btn pa-1" min-width="24" width="24" height="24" elevation="0" variant="text" @click="clearSearchKeyword">
                <funnow-icon class="wd-w-4" max-width="16" :image-path="'remove-icon_gray.svg'" />
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </slot>
    </div>

    <h2 v-if="shouldIntroShow" class="wd-text-base wd-font-normal wd-bg-white wd-px-5 wd-pt-1 wd-pb-2">
      {{ category.intro || firstLevelCategory.intro }}
    </h2>

    <div
      v-if="shouldShowRegionSearchBar"
      v-intersect="{ handler: onEmbeddedSearchBarIntersect, options: { threshold: 0, rootMargin: '-60px 0px 0px 0px' } }"
      class="wd-px-5 wd-pt-1 wd-pb-6 wd-bg-white"
    >
      <RegionSearchBarMobile
        :show-category-and-now="false"
        :region="region"
        :search-keywords-of-region="searchKeywordsOfRegion"
        :headcount-options="headcountOptions"
        @update-filter-data="onSearchBarFilterUpdate"
      />
    </div>

    <BannersSwiper
      v-if="shouldBannerShow"
      class="wd-block wd-relative"
      :isMobile="true"
      ui-type="category"
      :items="firstLevelCategory.banner || []"
      :is-single-slide-per-view="true"
    />

    <div class="categories__tools wd-contents">
      <div
        v-if="shouldSubcategoryShow"
        ref="subcatergoryBarRef"
        class="wd-sticky wd-z-categoryInfoMobile"
        :style="{ top: `${subcatergoryBarTop}px` }"
      >
        <v-tabs
          v-model="currentTabId"
          class="subcatergoryBar wd-pl-5"
          :class="{ subcategoryWithImage: isSubcategoryImageShow && !isFixedTop }"
          color="orange50"
          bg-color="white"
        >
          <v-tab class="subcategoryTab wd-flex wd-flex-col" :value="firstLevelCategory.id" @click="handleTabClick(firstLevelCategory.id)">
            <img v-if="isSubcategoryImageShow && !isFixedTop" class="wd-mb-2" :src="getMediaCdnUrl(firstLevelCategory.icon_image)" />
            {{ $t('all_sub_category') }}
          </v-tab>

          <v-tab
            v-for="subcategory in subcategories"
            :key="subcategory.id"
            class="subcategoryTab wd-flex wd-flex-col"
            :value="subcategory.id"
            @click="handleTabClick(subcategory.id)"
          >
            <img v-if="isSubcategoryImageShow && !isFixedTop" class="wd-mb-2" :src="getMediaCdnUrl(subcategory.icon_image)" />
            {{ subcategory.name }}
          </v-tab>
        </v-tabs>
      </div>

      <v-slide-group
        ref="filterBarRef"
        class="filter-bar wd-sticky wd-z-categoryInfoMobile wd-bg-white"
        :show-arrows="false"
        :style="{ top: `${filterBarTop}px` }"
      >
        <v-slide-group-item>
          <v-btn
            class="filter-btn mr-2"
            :class="{ selected: selectedNowBtn }"
            min-width="100"
            height="32"
            elevation="0"
            variant="outlined"
            @click="updateNowConCondition"
          >
            <FunnowSvgIcon class="mr-2" max-width="20" :image-path="'flash-icon_current.svg'" />
            {{ $t('filter_now') }}
          </v-btn>
        </v-slide-group-item>

        <v-slide-group-item v-for="(filter, idx) in filterChips" :key="filter.name">
          <v-bottom-sheet v-model="filterWindowsStatus.chips[idx]" persistent>
            <template #activator="{ isActive, props }">
              <v-btn
                class="filter-btn mr-2"
                :class="{ selected: isActive || filter.activated }"
                min-width="80"
                height="32"
                elevation="0"
                variant="outlined"
                v-bind="props"
              >
                <FunnowSvgIcon v-if="filter.icon" class="mr-2" max-width="20" :image-path="`${filter.icon}.svg`" />
                {{ filter.text || filter.placeholder }}
              </v-btn>
            </template>

            <FilterContextCard
              v-if="filterWindowsStatus.chips[idx]"
              :clear-btn="filter.clearBtn"
              :currency="currency.value"
              :sort="sort"
              :index="idx"
              :title="filter.title"
              :content-type="filter.type"
              :filter-key="filter.key"
              :filter-value="filter.value"
              :filter-options="filter.options"
              :current-filter="currentFilter"
              :current-tag-filter="filterTagSettingMap"
              :date-mode="filter.dayMode"
              :total-count="totalCount"
              :filter-selected="filter.activated"
              :key-value="filter.keyValue"
              :is-branch-card-mode="isBranchCardMode"
              type="chips"
              @confirm="updateCondition"
              @close="closedMenuValue"
            />
          </v-bottom-sheet>
        </v-slide-group-item>

        <v-slide-group-item v-for="(filter, idx) in filterTags" :key="idx">
          <v-bottom-sheet v-model="filterWindowsStatus.tags[idx]" persistent>
            <template #activator="{ isActive, props }">
              <v-btn
                class="filter-btn mr-3"
                :class="{ selected: isActive || filter.activated }"
                min-width="80"
                height="32"
                elevation="0"
                variant="outlined"
                v-bind="props"
              >
                {{ filter.text || filter.title }}
                <funnow-icon
                  class="ml-2"
                  max-width="24"
                  :image-path="`chevron-${isActive ? 'up' : 'down'}${isActive || filter.activated ? '_orange' : ''}.svg`"
                />
              </v-btn>
            </template>

            <FilterContextCard
              v-if="filterWindowsStatus.tags[idx]"
              :clear-btn="filter.clearBtn"
              :sort="sort"
              :index="idx"
              :title="filter.title"
              :filter-key="filter.key"
              :content-type="filter.type"
              :filter-value="filter.value"
              :filter-options="filter.options"
              :current-filter="currentFilter"
              :current-tag-filter="filterTagSettingMap"
              :date-mode="filter.dayMode"
              :total-count="totalCount"
              :filter-selected="filter.activated"
              :key-value="filter.keyValue"
              :is-branch-card-mode="isBranchCardMode"
              type="tags"
              @confirm="updateCondition"
              @close="closedMenuValue"
            />
          </v-bottom-sheet>
        </v-slide-group-item>
      </v-slide-group>

      <div ref="sortBarRef" class="sort-bar wd-bg-white wd-sticky wd-z-1" :style="{ top: `${sortBarTop}px` }">
        <v-bottom-sheet v-model="sortBottomValue" persistent>
          <template #activator="{ props }">
            <!-- 排序選擇 -->
            <v-btn class="sort-btn" max-height="32" variant="text" v-bind="props">
              <funnow-icon class="mr-1" max-width="20" :image-path="'sort-icon_black.svg'" />
              {{ sortText }}
            </v-btn>
          </template>

          <FilterContextCard
            v-if="sortBottomValue"
            :clear-btn="false"
            :sort="sort"
            :title="$t('filter_sorting')"
            :content-type="'list'"
            :filter-value="sort"
            :filter-options="sortItems"
            :current-filter="currentFilter"
            :current-tag-filter="filterTagSettingMap"
            :key-value="['sort']"
            :is-branch-card-mode="isBranchCardMode"
            :is-debounce="false"
            type="default"
            @confirm="doSort"
            @close="closedSortValue"
          />
        </v-bottom-sheet>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'
import filterSetting from '@/composition/filter-setting'
import utils from '@/utils'
import { CategorySortKey, FilterFromPage } from '@/constants/filters'

import SearchBar from '@/components/search/search-bar.vue'
import RegionSearchBarMobile from '@/components/page/regions/search-bar--mobile.vue'
import { useRegionSearchBarVisibility } from '@/composables/useRegionSearchBarVisibility'
import { useFilterChipsSync } from '@/composables/useFilterChipsSync'
import BannersSwiper from '@/components/swiper/banner-swiper.vue'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
import FilterContextCard from '@/components/page/categories/mobile/filter-context-card.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'

export default defineComponent({
  name: 'CategoryInfoSheetMobile',
  components: {
    SearchBar,
    BannersSwiper,
    FilterContextCard,
    FunnowIcon,
    FunnowSvgIcon,
    RegionSearchBarMobile,
  },
  props: {
    region: { type: Object, default: () => ({}) },
    category: { type: Object, default: () => ({}) },
    subcategoryId: { type: Number, default: 0 },
    dayMode: { type: Number, default: 1 },
    totalCount: { type: Number, default: 0 },
    filters: { type: Object, default: () => ({}) },
    isFixedTop: { type: Boolean, default: false },
    searchKeyWord: { type: String, default: '' },
    hasGeolocation: { type: Boolean, default: false },
    fromPage: { type: String, default: '' },
    hasCategoryInfo: { type: Boolean, default: true },
    isBranchCardMode: { type: Boolean, default: true },
    firstLevelCategoryId: { type: Number, default: 0 },
    tagId: { type: Number, default: null },
  },
  emits: ['updateCondition', 'categoryChange'],
  setup(props) {
    const {
      sort,
      currency,
      filterWindowsStatus,
      filterChips,
      filterTags,
      initFilters,
      initSearchFilters,
      initTagFilters,
      getFilterParams,
      currentFilters,
      selectedNowBtn,
      fetchSearchKeywords,
      setDataToRenderFilterChips,
      setDataToRenderFilterTags,
      updateFilterCondition,
      clickNowFilter,
      closedMenuValue,
    } = filterSetting(props)
    const currentTabId = ref(props.subcategoryId || 0)
    const nuxtApp = useNuxtApp()

    const searchBarRef = useTemplateRef('searchBarRef')
    const subcatergoryBarRef = useTemplateRef('subcatergoryBarRef')
    const filterBarRef = useTemplateRef('filterBarRef')
    const sortBarRef = useTemplateRef('sortBarRef')
    const { height: searchBarHeight } = useElementSize(searchBarRef, undefined, { box: 'border-box' })
    const { height: subcatergoryBarHeight } = useElementSize(subcatergoryBarRef, undefined, { box: 'border-box' })
    const { height: filterBarHeight } = useElementSize(filterBarRef, undefined, { box: 'border-box' })
    const { height: sortBarHeight } = useElementSize(sortBarRef, undefined, { box: 'border-box' })

    const firstLevelCategory = computed(() => nuxtApp.$store.getters['category/firstLevelCategory'])
    const subcategories = computed(() => nuxtApp.$store.getters['category/subcategories'])

    // Validate that firstLevelCategory belongs to the current route's category,
    // preventing the old page from mounting BannersSwiper when the Vuex store is
    // updated with new category data during Nuxt Suspense navigation.
    const shouldBannerShow = computed(
      () => props.hasCategoryInfo && !!firstLevelCategory.value.banner?.length && firstLevelCategory.value.id === props.firstLevelCategoryId
    )
    const shouldSubcategoryShow = computed(() => props.hasCategoryInfo && !props.searchKeyWord && subcategories.value.length > 0)
    const shouldIntroShow = computed(() => props.hasCategoryInfo && !!(props.category.intro || firstLevelCategory.value.intro))
    const subcatergoryBarTop = computed(() => searchBarHeight.value)

    const { shouldShowRegionSearchBar } = useRegionSearchBarVisibility(
      computed(() => props.filters),
      firstLevelCategory
    )
    const filterBarTop = computed(() => searchBarHeight.value + subcatergoryBarHeight.value)
    /**
     * The overlap (filterBarHeight - sortBarHeight) is intentional: sort bar has shadow effect,
     * so it's deliberately positioned behind filter bar to create a layered visual effect
     */
    const sortBarTop = computed(() => searchBarHeight.value + subcatergoryBarHeight.value + (filterBarHeight.value - sortBarHeight.value))

    useFilterChipsSync(currentFilters, setDataToRenderFilterChips, setDataToRenderFilterTags)

    return {
      firstLevelCategory,
      subcategories,
      shouldBannerShow,
      shouldSubcategoryShow,
      shouldIntroShow,
      shouldShowRegionSearchBar,
      currentTabId,
      sort,
      currency,
      filterWindowsStatus,
      filterChips,
      filterTags,
      subcatergoryBarTop,
      filterBarTop,
      sortBarTop,
      initFilters,
      initSearchFilters,
      initTagFilters,
      getFilterParams,
      currentFilters,
      selectedNowBtn,
      fetchSearchKeywords,
      updateFilterCondition,
      clickNowFilter,
      closedMenuValue,
      setDataToRenderFilterChips,
      getMediaCdnUrl: utils.getMediaCdnUrl,
    }
  },
  data() {
    return {
      searchInputOpening: false,
      sortBottomValue: false,
    }
  },
  computed: {
    currentFilter() {
      if (this.$route.query.source_category_id && !this.searchKeyWord) {
        return {
          filter_regionid: this.region.id,
          category_id: this.firstLevelCategory.id,
          sub_category_id: this.subcategoryId,
          filter_keyword: this.searchKeyWord,
          ...this.currentFilters,
        }
      }

      return {
        filter_regionid: this.region.id,
        ...(this.tagId && { filter_tag: `${this.tagId}` }),
        ...(this.firstLevelCategory.id && { category_id: this.firstLevelCategory.id }),
        filter_keyword: this.searchKeyWord,
        ...this.currentFilters,
      }
    },
    isSubcategoryImageShow() {
      return this.subcategories.every(e => !!e.icon_image) && !!this.firstLevelCategory.icon_image
    },
    sortText() {
      let sortIndex = 0
      sortIndex = (this.sortItems || []).findIndex(sortObj => {
        return sortObj.value === this.sort
      })
      if (sortIndex > 0) {
        return this.sortItems[sortIndex].title
      }
      return ''
    },
    sortItems() {
      const defaultSortItems = [
        { title: this.$t('sort_hot'), value: CategorySortKey.POPULAR },
        { title: this.$t('sort_price_high_to_low'), value: CategorySortKey.PRICE_HIGH },
        { title: this.$t('sort_price_low_to_high'), value: CategorySortKey.PRICE_LOW },
      ]

      if (this.hasGeolocation) {
        defaultSortItems[0].value = CategorySortKey.POPULAR_OVER_DISTANCE
        defaultSortItems.unshift({ title: this.$t('sort_distance'), value: CategorySortKey.DISTANCE })
      }
      return defaultSortItems
    },
    isSearchInputRowShow() {
      return !!this.searchKeyWord && this.searchInputOpening
    },
    ...mapGetters({
      filterTagSettingMap: 'filter/filterTags',
      searchKeywordsOfRegion: 'search/searchKeywordsOfRegion',
      isEmbeddedSearchBarVisible: 'isEmbeddedSearchBarVisible',
    }),
    headcountOptions() {
      const components = this.filters?.components || []
      const headcountComp = components.find(c => c.name === 'headcount')
      return headcountComp?.options || []
    },
  },
  watch: {
    searchKeyWord(newVal) {
      if (newVal) {
        this.searchInputOpening = true
      }
    },
    filters(newData) {
      if (!newData?.components) return
      this.determineWhichPageAndInitFilters()
    },
  },
  created() {
    this.determineWhichPageAndInitFilters()
    this.searchInputOpening = !!this.searchKeyWord
  },
  methods: {
    handleTabClick(categoryId) {
      if (categoryId === this.firstLevelCategory.id) {
        this.$emit('categoryChange', this.firstLevelCategory)
        return
      }
      const selectedSubcategory = this.subcategories.find(e => e.id === categoryId)
      if (selectedSubcategory) {
        this.$emit('categoryChange', selectedSubcategory)
      }
    },
    determineWhichPageAndInitFilters() {
      switch (this.fromPage) {
        case FilterFromPage.SEARCH:
          this.initSearchFilters()
          break
        case FilterFromPage.TAG:
          this.initTagFilters()
          break
        default: {
          const hasCusNum = this.category.has_cus_num
          const hasTimeFilter = this.category.has_time_filter
          this.initFilters({ hasCusNum, hasTimeFilter })
        }
      }
    },
    updateNowConCondition() {
      this.clickNowFilter()
      const filterData = this.getFilterParams()
      this.emitToUpper(filterData)
    },
    updateCondition(response) {
      const filterData = this.updateFilterCondition(response)
      this.emitToUpper(filterData)
    },
    onSearchBarFilterUpdate() {
      // Use getFilterParams() instead of the partial `filters` param from the search bar.
      // Same fix as category-info-sheet.vue: the store is already updated synchronously
      // before this event fires, so getFilterParams() returns the full merged filter state.
      this.emitToUpper(this.getFilterParams())
    },
    closedSortValue() {
      this.sortBottomValue = false
    },
    doSort({ params }) {
      if (params.sort) {
        this.sort = params.sort
        const filterData = this.getFilterParams(this.currentFilters)
        this.emitToUpper(filterData)
      }
      this.closedSortValue()
    },
    leaveingSearchInput() {
      this.searchInputOpening = false
    },
    openSearchNavigation() {
      this.$store.dispatch('setSearchNavigation', true)
    },
    clearSearchKeyword() {
      this.openSearchNavigation()
      this.$store.dispatch('search/setSearchKeyword', '')
    },
    onEmbeddedSearchBarIntersect(isIntersecting) {
      this.$store.dispatch('setEmbeddedSearchBarVisible', this.shouldShowRegionSearchBar && isIntersecting)
    },
    emitToUpper(filter = {}) {
      this.$emit('updateCondition', { sort: this.sort, filter })
    },
  },
})
</script>

<style scoped lang="scss">
.category-info-sheet--mobile {
  .categories {
    &__tools {
      .subcatergoryBar {
        :deep(.v-slide-group__prev) {
          display: none !important;
        }
        :deep(.v-tabs-bar) {
          height: 48px;
        }
        &.subcategoryWithImage {
          :deep(.v-tabs-bar) {
            height: 80px;
          }
        }

        .subcategoryTab {
          &.v-tab {
            font-size: $baseFontSize;
            font-weight: 400;
            text-transform: none;
            letter-spacing: 0;
            &:not(.v-tab--selected) {
              /* to override a tag color */
              color: $black50 !important;
            }
          }

          img {
            width: 24px;
            height: 24px;
          }
        }
      }

      .filter-bar {
        max-width: calc(100vw);

        .filter-btn {
          margin: 8px 0;
          background-color: white;
          border-color: $gray50 !important;
          color: $black50 !important;
          font-size: 15px;

          &:first-child {
            margin-left: 20px;
          }

          &.selected {
            border-color: $orange50 !important;
            color: $orange50 !important;
          }
        }
      }

      .sort-bar {
        padding: 4px 0;
        text-align: right;
        box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.1);

        .sort-btn {
          margin-right: 4px;
          font-size: 15px;
        }
        &.hide {
          display: none;
        }
      }
    }
  }
}
</style>
